import React from "react";
import ContainerHeader from "components/ContainerHeader/index";
import IntlMessages from "util/IntlMessages";
import { Button } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';
import FileCard from './FileCard';



const MyFiles = ({ match }) => {
  return (

    <div className="dashboard animated slideInUpTiny animation-duration-3">


<ContainerHeader match={match} title={"I miei file"} />

      <div className="row">
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
        <NavLink to="/app/folders">
        <Button className="void">
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />

                <span className="nav-text">Indietro</span>

              </Button>
         
        </NavLink>

        &nbsp;&nbsp;&nbsp;

        <NavLink to="/app/extensions/dropzone">
        <Button className="void">
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />

                <span className="nav-text">Upload File</span>

              </Button>
         
        </NavLink>
      </div>




      <div className="row">

        <div className="col-xl-8 col-lg-8 col-md-12 col-12 order-sm-1">


          <FileCard />
        </div>
      </div>
    </div>
  );
};

export default MyFiles;
